import { PageLayout } from '@/layouts/page-layout'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@table-library/react-table-library/theme'
import { Outlet, Link, useLoaderData, Await } from 'react-router-dom'
import { ContractFilter } from '@/components/contract-filter'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import {
  CreateButton,
  DownloadButton
} from '@/shared/components/action-buttons'
import { HasAccess } from '@permify/react-role'
import { ContractTable } from './tables'
import { Suspense } from 'react'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'

export const ContractList = () => {
  const { t } = useTranslation()

  const promises = useLoaderData()

  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: repeat(2, 1fr) max(300px) repeat(8, 1fr);
    `,
    BaseCell: `
      &:nth-of-type(11) {
        right: 0px;
      }
    `
  })

  return (
    <PageLayout
      title={t('contract.other')}
      actions={[
        <div className='flex gap gap-3' key='1'>
          <ContractFilter />
          <LinkWithQuery to='reports'>
            <DownloadButton />
          </LinkWithQuery>
          <HasAccess permissions={['contract#create']}>
            <Link key='new_contract' to='new'>
              <CreateButton />
            </Link>
          </HasAccess>
        </div>
      ]}
    >

      <Outlet />
      <Suspense fallback={<PageLayoutOverlay />}>
        <Await
          resolve={promises.contracts}
          errorElement={<PageLayoutError message='No se pudieron cargar los contratos' />}
        >
          {(contractsData) => (
            <ContractTable data={contractsData} theme={theme} />
          )}

        </Await>
      </Suspense>
    </PageLayout >
  )
}
